import { Menu } from "@mantine/core";

import Icon                    from "_components/atoms/icon";
import Render                  from "_components/atoms/render";
import { useGetUpdateSession } from "_jotai/liveSession";

import Avatar          from "./avatar";
import ChatText        from "./chatText";
import useStyles       from "./styles/NormalComment";
import UserNameAndTags from "./usernameAndTags";

const NormalComment = ( {
	data,
	onClickOptions,
	emotesList,
	isStreamer,
	isModerator,
	hideMenuOptionButton,
	userPopover
} ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const sessionData = useGetUpdateSession ();

	return (
		<div className = { classes.nameAndCommentContainerInNormalChat }>
			<Avatar
				photo = { data.sportsFan.photo }
				sportsFanId = { data.sportsFan.id }
			/>

			<div className = { classes.userNameAndCommentInMagicChat }>
				<UserNameAndTags
					data = { data }
				/>

				<span className = { classes.commentText }>
					<ChatText
						emotesList = { emotesList }
						text = { data.commentText }
					/>
				</span>

			</div>

			<Render condition = { !hideMenuOptionButton }>
				<CommentMenu
					data = { data }
					isModerator = { isModerator }
					isSessionLive = { sessionData?.isLive }
					isStreamer = { isStreamer }
					onClickOptions = { onClickOptions }
					userPopover = { userPopover }
				/>
			</Render>
		</div>
	);
};

export default NormalComment;

function CommentMenu ( {
	isSessionLive,
	onClickOptions,
	data,
	userPopover,
	isStreamer,
	isModerator
} ) {
	const { classes, theme } = useStyles ( undefined, { name: "styles" } );

	if ( !isSessionLive ) return null;

	// options will show only in normal chat when user is streamer
	if ( data.commentType === "MAGIC_CHAT" || data.commentType === "STREAM_DONATION" )
		return null;

	if ( !isStreamer && !isModerator )
		return null;

	return (
		<Menu
			arrowSize = { 8 }
			closeOnItemClick = { false }
			offset = { { crossAxis: 10 } }
			radius = { "md" }
			styles = { {
				dropdown: {
					border          : "none",
					boxShadow       : theme.other.colors.boxShadow.primary,
					backgroundColor : theme.other.colors.background.primary,
					padding         : "0 !important"
				},
				item: {
					padding      : "0.75rem 1.5rem",
					borderRadius : "0",
					margin       : "0"
				}
			} }
			withinPortal = { true }
		>
			<Menu.Target>
				<div onClick = { e => onClickOptions ( e, data ) }
					style = { { cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" } }
				>

					<Icon
						className = { `${ classes.svgIcon } optionsButtonInChat` }
						name = "threeDotMenu"
					/>
				</div>
			</Menu.Target>

			{userPopover}

		</Menu>
	);
}
